import { render, staticRenderFns } from "./auction-bids.vue?vue&type=template&id=c6d4375c&"
import script from "./auction-bids.vue?vue&type=script&lang=js&"
export * from "./auction-bids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports